/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DatasetBriefDto } from './DatasetBriefDto';
import type { GetCollaborationToolItemDto } from './GetCollaborationToolItemDto';
import type { IncidentTeamDto } from './IncidentTeamDto';
import type { RuleBriefDto } from './RuleBriefDto';
import type { UserDto } from './UserDto';

export type IncidentExternalDto = {
    collaborationToolItems: Array<GetCollaborationToolItemDto>;
    compromisedAssets: number;
    criticality: number;
    datasets: Array<DatasetBriefDto>;
    id: string;
    isMutedIndefinitely: boolean;
    issueNo: number;
    lastModifiedDate?: number;
    lastOccurredDate: number;
    mutedUntil?: number;
    name: string;
    owners: Array<UserDto>;
    qualification?: IncidentExternalDto.qualification;
    rules: Array<RuleBriefDto>;
    siffletUrl: string;
    status: IncidentExternalDto.status;
    teams: Array<IncidentTeamDto>;
    triggerTime: number;
};

export namespace IncidentExternalDto {

    export enum qualification {
        FIXED = 'FIXED',
        FALSE_POSITIVE = 'FALSE_POSITIVE',
        NO_ACTION_NEEDED = 'NO_ACTION_NEEDED',
        DUPLICATE = 'DUPLICATE',
        AUTOMATIC = 'AUTOMATIC',
    }

    export enum status {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        CLOSED = 'CLOSED',
    }


}
